// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","caption2":"_3FCgXshmQfWC83mTTDn6Lf","caption":"_1dJD2pSCq2-UhXWE_3mRfd","errorRed":"#ff2a2a","borderGrey":"#d5dfdf","label":"QtMv_n6BEgPQM_pcxpn8o _3FCgXshmQfWC83mTTDn6Lf","error":"_2h0zrRsiZTQLVsHCb_6i63 _1dJD2pSCq2-UhXWE_3mRfd","input":"_26MC8GexenfsIUu3WI4OyP"};


//////////////////
// WEBPACK FOOTER
// ./src/common/basic-input/BasicInput.css
// module id = 286
// module chunks = 0 1 2